import { UpperCasePipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppsDataResponse, AppsService } from 'aih-launchpad-core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-apps-card',
  imports: [
    TranslatePipe,
    UpperCasePipe
  ],
  templateUrl: './apps-card.component.html',
  styleUrl: './apps-card.component.sass',
  standalone: true
})
export class AppsCardComponent implements OnInit, OnDestroy {
  private appsService = inject(AppsService);

  apps: AppsDataResponse[] = [];
  hyperlinks: AppsDataResponse[] = [];
  appsComingSoon: AppsDataResponse[] = [];
  loading: boolean = true;

  subscription?: Subscription;

  ngOnInit(): void {
    this.subscription = this.appsService.getApps().subscribe(data => {
      this.apps = data.filter(a => !a.isHyperlink && !a.isComingSoon);
      this.hyperlinks = data.filter(a => a.isHyperlink && !a.isComingSoon);
      this.appsComingSoon = data.filter(a => a.isComingSoon);
      this.loading = false;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
